import React from 'react'
import './Intro.css'
import profile from './profile.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'


function Intro() {
  const handleDownloadResume = () => {
    const link = document.createElement('a')
    link.href = '/resume.pdf'
    link.download = 'Edsel_Hernandez_Resume.pdf'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <section className="intro_container" id="home">
      <div className="intro_content">
        <h1 className="intro_title">Hi, I’m Edsel.</h1>
        <p className="intro_subtitle">Computer Science Student & Aspiring Software Engineer.</p>
        <div className="intro_cta_row">
          <a href="#projects" className="intro_cta_primary">View Projects</a>
          <button type="button" className="intro_cta_secondary" onClick={handleDownloadResume}>
            Resume
          </button>
          <a href="https://github.com/edsel090" target="_blank" rel="noopener noreferrer" className="intro_cta_github">
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a href= "https://www.linkedin.com/in/edsel-hernandez/" target="_blank" rel= "noopener noreferrer" className="intro_linkedln">
            <FontAwesomeIcon icon = {faLinkedin} />
          </a>
        </div>
      </div>
      <div className="intro_avatar_wrap">
        <img src={profile} alt="Profile" className="intro_avatar" />
      </div>

    </section>
  )
}

export default Intro